'use client';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Who Are We', href: '#who-are-we' },
    { label: 'Yoga TTC & Singing Bowls', href: '#courses' },
    { label: 'See Our World', href: '#see-our-world' },
    { label: 'Talk To Us', href: '#talk-to-us' },
    { label: 'Registration', href: '#registration' },
  ];

  return (
    <nav
      aria-label="Primary navigation"
      className={`sticky top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-cream/95 shadow-md backdrop-blur-sm py-3' : 'bg-cream/40 py-5'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-8">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2">
          <Image
            src="https://www.zenyoganepal.com/api/media/file/Gemini_Generated_Image_8kxk7n8kxk7n8kxk%20-%20Copy%20-%20Copy.png?prefix=uploads"
            alt="ZYN Nepal Logo"
            width={40}
            height={40}
            className="h-10 w-10 rounded-full object-contain"
            unoptimized
          />
          <span className="font-serif text-2xl font-bold tracking-wider text-forest">ZYN</span>
          <span className="rounded bg-saffron-light/20 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-widest text-saffron-dark">
            Nepal
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden items-center gap-8 lg:flex">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="relative py-1.5 font-sans text-sm font-medium tracking-wide transition-all text-charcoal/70 hover:text-forest"
            >
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="hidden items-center gap-3 sm:flex">
          <a
            href="/account"
            className="rounded-full border border-forest/20 px-5 py-2.5 font-sans text-sm font-bold tracking-wider text-forest transition-all hover:bg-forest/5"
          >
            My Account
          </a>
          <a
            href="#registration"
            className="rounded-full bg-gradient-to-r from-saffron-light to-saffron-dark px-6 py-2.5 font-sans text-sm font-bold tracking-wider text-white transition-all duration-300 hover:scale-[1.03] hover:shadow-lg"
          >
            Register Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          type="button"
          aria-label="Open navigation menu"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen(!mobileOpen)}
          className="p-1 text-forest hover:text-saffron-dark lg:hidden"
        >
          {mobileOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M18 6 6 18" /><path d="m6 6 12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 5h16" /><path d="M4 12h16" /><path d="M4 19h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          id="mobile-navigation"
          className="lg:hidden bg-cream/98 border-t border-forest/10 px-4 py-4 shadow-lg"
        >
          <div className="flex flex-col gap-3">
            {navLinks?.map((link) => (
              <a
                key={link?.href}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className="py-2 font-sans text-sm font-medium text-charcoal/80 hover:text-forest transition-colors border-b border-forest/5"
              >
                {link?.label}
              </a>
            ))}
            <div className="flex gap-3 pt-2">
              <a
                href="#registration"
                onClick={() => setMobileOpen(false)}
                className="flex-1 text-center rounded-full bg-gradient-to-r from-saffron-light to-saffron-dark px-4 py-2.5 font-sans text-sm font-bold text-white"
              >
                Register Now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
